import { TERMS_ROUTE } from '@hungryroot/routes';

export type RewardsFaqLinkedAnswer = {
  before: string;
  link: { label: string; href: string };
  after?: string;
};

export type RewardsFaqAnswer = string | RewardsFaqLinkedAnswer;

export interface RewardsFaqItem {
  question: string;
  answer: readonly RewardsFaqAnswer[];
  testIdSuffix: string;
}

export const REWARDS_FAQ_ITEMS: readonly RewardsFaqItem[] = [
  {
    question: 'How do I earn Reward Credits?',
    answer: [
      "We track the Credits you spend under your plan, plus any add-on Credits you purchase during your shopping window. We'll update your Overall Progress tracker within ~48 hours after your shopping window closes. Once you spend the number of Credits that correspond with the Reward milestones on the tracker, we'll add Reward Credits to your account that you can use on future orders.",
      'Please note you do not earn Reward Credits on Rollover Credits.',
    ],
    testIdSuffix: 'earn-rewards',
  },
  {
    question: 'How do I use my Reward Credits?',
    answer: [
      'Reward Credits are automatically applied to your cart (no code needed!) once you spend above your plan minimum and any available Rollover Credits have been applied. Please note that Reward Credits cannot be used toward your plan minimum.',
    ],
    testIdSuffix: 'use-rewards',
  },
  {
    question: 'Why do I have to spend my plan minimum?',
    answer: [
      "You must spend the minimum number of Credits in your plan to keep your subscription active — this is separate from Reward Credits. Reward Credits only kick in once you've spent the plan minimum and any available Rollover Credits. Think of it as: your usual order first, then Rollover Credits, then Reward Credits that you can use on additional items.",
    ],
    testIdSuffix: 'minimum-plan-credit',
  },
  {
    question:
      'I hit a Reward milestone! When will my Reward Credits be available to use?',
    answer: [
      "Once you've spent enough Credits to achieve a Reward milestone, your Reward Credits will be available to use within ~48 hours after the shopping window closes on the order with which you achieved that milestone. Any available Reward Credits will be shown in your Wallet and can be used on future orders.",
    ],
    testIdSuffix: 'use-free-credits',
  },
  {
    question: 'Do Reward Credits have a cash value?',
    answer: [
      'No. Reward Credits have no cash value, cannot be redeemed for cash, and are not transferable.',
    ],
    testIdSuffix: 'cash-value',
  },
  {
    question: 'Do my Reward Credits expire?',
    answer: [
      'Reward Credits remain available as long as your subscription is active. If you cancel, your Reward Credits will be lost.',
      {
        before: 'For full program terms, see our ',
        link: { label: 'Terms of Use', href: TERMS_ROUTE },
        after: '.',
      },
    ],
    testIdSuffix: 'expiration',
  },
];
